
// styles
require('@assets/styles/style.scss')

// scripts
require('@assets/js')

// svg sprites
// require.context('@assets/images/sprite/test', false, /\.svg$/)